export const MCP_OAUTH_SCOPES = ['requirements:read', 'requirements:write'] as const;

export const CURSOR_MCP_REDIRECT_URI = 'cursor://anysphere.cursor-mcp/oauth/callback';

export const MCP_SERVER_NAME = 'Arvid';
